import { default as about_45us5gatVue1ehMeta } from "/usr/src/nuxt-app/pages/about-us.vue?macro=true";
import { default as chargingOR0lvf9SVsMeta } from "/usr/src/nuxt-app/pages/account/charging.vue?macro=true";
import { default as conflict_45resolutionSxFCy4HiLiMeta } from "/usr/src/nuxt-app/pages/account/conflict-resolution.vue?macro=true";
import { default as faqSsNcYVujbmMeta } from "/usr/src/nuxt-app/pages/account/faq.vue?macro=true";
import { default as favoritesfWMeYTZIIyMeta } from "/usr/src/nuxt-app/pages/account/favorites.vue?macro=true";
import { default as locationQW81OdsB0EMeta } from "/usr/src/nuxt-app/pages/account/location.vue?macro=true";
import { default as _91id_93QBC42aQLLiMeta } from "/usr/src/nuxt-app/pages/account/orders/[id].vue?macro=true";
import { default as index04iyyzgaLNMeta } from "/usr/src/nuxt-app/pages/account/orders/index.vue?macro=true";
import { default as pointskM80ge9qHyMeta } from "/usr/src/nuxt-app/pages/account/points.vue?macro=true";
import { default as privacy_45policy7aqS3AyMa9Meta } from "/usr/src/nuxt-app/pages/account/privacy-policy.vue?macro=true";
import { default as profileSWncVXHcCrMeta } from "/usr/src/nuxt-app/pages/account/profile.vue?macro=true";
import { default as terms_45conditionspxm2epkwdPMeta } from "/usr/src/nuxt-app/pages/account/terms-conditions.vue?macro=true";
import { default as vehiclesPEaLhpMfQUMeta } from "/usr/src/nuxt-app/pages/account/vehicles.vue?macro=true";
import { default as basketozsSOZxksxMeta } from "/usr/src/nuxt-app/pages/basket.vue?macro=true";
import { default as checkoutZI1eoq356MMeta } from "/usr/src/nuxt-app/pages/checkout.vue?macro=true";
import { default as comparepVRImrnCKwMeta } from "/usr/src/nuxt-app/pages/compare.vue?macro=true";
import { default as indexAoBMx6PnC1Meta } from "/usr/src/nuxt-app/pages/index.vue?macro=true";
import { default as loginlzkgvgJgWgMeta } from "/usr/src/nuxt-app/pages/login.vue?macro=true";
import { default as onboardingyCIg03afmaMeta } from "/usr/src/nuxt-app/pages/onboarding.vue?macro=true";
import { default as failedotKrgFuEeYMeta } from "/usr/src/nuxt-app/pages/order/failed.vue?macro=true";
import { default as successCgk9DRWwyJMeta } from "/usr/src/nuxt-app/pages/order/success.vue?macro=true";
import { default as _91product_93MsMn0oFWRLMeta } from "/usr/src/nuxt-app/pages/product/[product].vue?macro=true";
import { default as _91product_93b9yB5VgZ3NMeta } from "/usr/src/nuxt-app/pages/products/[category]/[product].vue?macro=true";
import { default as index8NbV7IN41TMeta } from "/usr/src/nuxt-app/pages/products/[category]/index.vue?macro=true";
import { default as indexXwucbuvb3yMeta } from "/usr/src/nuxt-app/pages/products/index.vue?macro=true";
import { default as _91slug_93dQsYLeaJlwMeta } from "/usr/src/nuxt-app/pages/promotions/[slug].vue?macro=true";
import { default as registeraxIneg16bwMeta } from "/usr/src/nuxt-app/pages/register.vue?macro=true";
import { default as update_45usercprgsEMgM9Meta } from "/usr/src/nuxt-app/pages/update-user.vue?macro=true";
import { default as component_45stub080fa1cgF9Meta } from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub080fa1cgF9 } from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about-us___pt",
    path: "/pt/about-us",
    component: () => import("/usr/src/nuxt-app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___es",
    path: "/es/about-us",
    component: () => import("/usr/src/nuxt-app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___en",
    path: "/about-us",
    component: () => import("/usr/src/nuxt-app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___fr",
    path: "/fr/about-us",
    component: () => import("/usr/src/nuxt-app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "account-charging___pt",
    path: "/pt/account/charging",
    meta: chargingOR0lvf9SVsMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/charging.vue").then(m => m.default || m)
  },
  {
    name: "account-charging___es",
    path: "/es/account/charging",
    meta: chargingOR0lvf9SVsMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/charging.vue").then(m => m.default || m)
  },
  {
    name: "account-charging___en",
    path: "/account/charging",
    meta: chargingOR0lvf9SVsMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/charging.vue").then(m => m.default || m)
  },
  {
    name: "account-charging___fr",
    path: "/fr/account/charging",
    meta: chargingOR0lvf9SVsMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/charging.vue").then(m => m.default || m)
  },
  {
    name: "account-conflict-resolution___pt",
    path: "/pt/account/conflict-resolution",
    meta: conflict_45resolutionSxFCy4HiLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/conflict-resolution.vue").then(m => m.default || m)
  },
  {
    name: "account-conflict-resolution___es",
    path: "/es/account/conflict-resolution",
    meta: conflict_45resolutionSxFCy4HiLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/conflict-resolution.vue").then(m => m.default || m)
  },
  {
    name: "account-conflict-resolution___en",
    path: "/account/conflict-resolution",
    meta: conflict_45resolutionSxFCy4HiLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/conflict-resolution.vue").then(m => m.default || m)
  },
  {
    name: "account-conflict-resolution___fr",
    path: "/fr/account/conflict-resolution",
    meta: conflict_45resolutionSxFCy4HiLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/conflict-resolution.vue").then(m => m.default || m)
  },
  {
    name: "account-faq___pt",
    path: "/pt/account/faq",
    meta: faqSsNcYVujbmMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/faq.vue").then(m => m.default || m)
  },
  {
    name: "account-faq___es",
    path: "/es/account/faq",
    meta: faqSsNcYVujbmMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/faq.vue").then(m => m.default || m)
  },
  {
    name: "account-faq___en",
    path: "/account/faq",
    meta: faqSsNcYVujbmMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/faq.vue").then(m => m.default || m)
  },
  {
    name: "account-faq___fr",
    path: "/fr/account/faq",
    meta: faqSsNcYVujbmMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/faq.vue").then(m => m.default || m)
  },
  {
    name: "account-favorites___pt",
    path: "/pt/account/favorites",
    meta: favoritesfWMeYTZIIyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/favorites.vue").then(m => m.default || m)
  },
  {
    name: "account-favorites___es",
    path: "/es/account/favorites",
    meta: favoritesfWMeYTZIIyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/favorites.vue").then(m => m.default || m)
  },
  {
    name: "account-favorites___en",
    path: "/account/favorites",
    meta: favoritesfWMeYTZIIyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/favorites.vue").then(m => m.default || m)
  },
  {
    name: "account-favorites___fr",
    path: "/fr/account/favorites",
    meta: favoritesfWMeYTZIIyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/favorites.vue").then(m => m.default || m)
  },
  {
    name: "account-location___pt",
    path: "/pt/account/location",
    meta: locationQW81OdsB0EMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/location.vue").then(m => m.default || m)
  },
  {
    name: "account-location___es",
    path: "/es/account/location",
    meta: locationQW81OdsB0EMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/location.vue").then(m => m.default || m)
  },
  {
    name: "account-location___en",
    path: "/account/location",
    meta: locationQW81OdsB0EMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/location.vue").then(m => m.default || m)
  },
  {
    name: "account-location___fr",
    path: "/fr/account/location",
    meta: locationQW81OdsB0EMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/location.vue").then(m => m.default || m)
  },
  {
    name: "account-orders-id___pt",
    path: "/pt/account/orders/:id()",
    meta: _91id_93QBC42aQLLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-orders-id___es",
    path: "/es/account/orders/:id()",
    meta: _91id_93QBC42aQLLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-orders-id___en",
    path: "/account/orders/:id()",
    meta: _91id_93QBC42aQLLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-orders-id___fr",
    path: "/fr/account/orders/:id()",
    meta: _91id_93QBC42aQLLiMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: "account-orders___pt",
    path: "/pt/account/orders",
    meta: index04iyyzgaLNMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "account-orders___es",
    path: "/es/account/orders",
    meta: index04iyyzgaLNMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "account-orders___en",
    path: "/account/orders",
    meta: index04iyyzgaLNMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "account-orders___fr",
    path: "/fr/account/orders",
    meta: index04iyyzgaLNMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "account-points___pt",
    path: "/pt/account/points",
    meta: pointskM80ge9qHyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/points.vue").then(m => m.default || m)
  },
  {
    name: "account-points___es",
    path: "/es/account/points",
    meta: pointskM80ge9qHyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/points.vue").then(m => m.default || m)
  },
  {
    name: "account-points___en",
    path: "/account/points",
    meta: pointskM80ge9qHyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/points.vue").then(m => m.default || m)
  },
  {
    name: "account-points___fr",
    path: "/fr/account/points",
    meta: pointskM80ge9qHyMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/points.vue").then(m => m.default || m)
  },
  {
    name: "account-privacy-policy___pt",
    path: "/pt/account/privacy-policy",
    meta: privacy_45policy7aqS3AyMa9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "account-privacy-policy___es",
    path: "/es/account/privacy-policy",
    meta: privacy_45policy7aqS3AyMa9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "account-privacy-policy___en",
    path: "/account/privacy-policy",
    meta: privacy_45policy7aqS3AyMa9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "account-privacy-policy___fr",
    path: "/fr/account/privacy-policy",
    meta: privacy_45policy7aqS3AyMa9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "account-profile___pt",
    path: "/pt/account/profile",
    meta: profileSWncVXHcCrMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/profile.vue").then(m => m.default || m)
  },
  {
    name: "account-profile___es",
    path: "/es/account/profile",
    meta: profileSWncVXHcCrMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/profile.vue").then(m => m.default || m)
  },
  {
    name: "account-profile___en",
    path: "/account/profile",
    meta: profileSWncVXHcCrMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/profile.vue").then(m => m.default || m)
  },
  {
    name: "account-profile___fr",
    path: "/fr/account/profile",
    meta: profileSWncVXHcCrMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/profile.vue").then(m => m.default || m)
  },
  {
    name: "account-terms-conditions___pt",
    path: "/pt/account/terms-conditions",
    meta: terms_45conditionspxm2epkwdPMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/terms-conditions.vue").then(m => m.default || m)
  },
  {
    name: "account-terms-conditions___es",
    path: "/es/account/terms-conditions",
    meta: terms_45conditionspxm2epkwdPMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/terms-conditions.vue").then(m => m.default || m)
  },
  {
    name: "account-terms-conditions___en",
    path: "/account/terms-conditions",
    meta: terms_45conditionspxm2epkwdPMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/terms-conditions.vue").then(m => m.default || m)
  },
  {
    name: "account-terms-conditions___fr",
    path: "/fr/account/terms-conditions",
    meta: terms_45conditionspxm2epkwdPMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/terms-conditions.vue").then(m => m.default || m)
  },
  {
    name: "account-vehicles___pt",
    path: "/pt/account/vehicles",
    meta: vehiclesPEaLhpMfQUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/vehicles.vue").then(m => m.default || m)
  },
  {
    name: "account-vehicles___es",
    path: "/es/account/vehicles",
    meta: vehiclesPEaLhpMfQUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/vehicles.vue").then(m => m.default || m)
  },
  {
    name: "account-vehicles___en",
    path: "/account/vehicles",
    meta: vehiclesPEaLhpMfQUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/vehicles.vue").then(m => m.default || m)
  },
  {
    name: "account-vehicles___fr",
    path: "/fr/account/vehicles",
    meta: vehiclesPEaLhpMfQUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/account/vehicles.vue").then(m => m.default || m)
  },
  {
    name: "basket___pt",
    path: "/pt/basket",
    meta: basketozsSOZxksxMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___es",
    path: "/es/basket",
    meta: basketozsSOZxksxMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___en",
    path: "/basket",
    meta: basketozsSOZxksxMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fr",
    path: "/fr/basket",
    meta: basketozsSOZxksxMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout___pt",
    path: "/pt/checkout",
    meta: checkoutZI1eoq356MMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___es",
    path: "/es/checkout",
    meta: checkoutZI1eoq356MMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___en",
    path: "/checkout",
    meta: checkoutZI1eoq356MMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: checkoutZI1eoq356MMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "compare___pt",
    path: "/pt/compare",
    component: () => import("/usr/src/nuxt-app/pages/compare.vue").then(m => m.default || m)
  },
  {
    name: "compare___es",
    path: "/es/compare",
    component: () => import("/usr/src/nuxt-app/pages/compare.vue").then(m => m.default || m)
  },
  {
    name: "compare___en",
    path: "/compare",
    component: () => import("/usr/src/nuxt-app/pages/compare.vue").then(m => m.default || m)
  },
  {
    name: "compare___fr",
    path: "/fr/compare",
    component: () => import("/usr/src/nuxt-app/pages/compare.vue").then(m => m.default || m)
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/usr/src/nuxt-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/usr/src/nuxt-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/usr/src/nuxt-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/usr/src/nuxt-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login___pt",
    path: "/pt/login",
    meta: loginlzkgvgJgWgMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: loginlzkgvgJgWgMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginlzkgvgJgWgMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginlzkgvgJgWgMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "onboarding___pt",
    path: "/pt/onboarding",
    meta: onboardingyCIg03afmaMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/onboarding.vue").then(m => m.default || m)
  },
  {
    name: "onboarding___es",
    path: "/es/onboarding",
    meta: onboardingyCIg03afmaMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/onboarding.vue").then(m => m.default || m)
  },
  {
    name: "onboarding___en",
    path: "/onboarding",
    meta: onboardingyCIg03afmaMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/onboarding.vue").then(m => m.default || m)
  },
  {
    name: "onboarding___fr",
    path: "/fr/onboarding",
    meta: onboardingyCIg03afmaMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/onboarding.vue").then(m => m.default || m)
  },
  {
    name: "order-failed___pt",
    path: "/pt/order/failed",
    meta: failedotKrgFuEeYMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/failed.vue").then(m => m.default || m)
  },
  {
    name: "order-failed___es",
    path: "/es/order/failed",
    meta: failedotKrgFuEeYMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/failed.vue").then(m => m.default || m)
  },
  {
    name: "order-failed___en",
    path: "/order/failed",
    meta: failedotKrgFuEeYMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/failed.vue").then(m => m.default || m)
  },
  {
    name: "order-failed___fr",
    path: "/fr/order/failed",
    meta: failedotKrgFuEeYMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/failed.vue").then(m => m.default || m)
  },
  {
    name: "order-success___pt",
    path: "/pt/order/success",
    meta: successCgk9DRWwyJMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/success.vue").then(m => m.default || m)
  },
  {
    name: "order-success___es",
    path: "/es/order/success",
    meta: successCgk9DRWwyJMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/success.vue").then(m => m.default || m)
  },
  {
    name: "order-success___en",
    path: "/order/success",
    meta: successCgk9DRWwyJMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/success.vue").then(m => m.default || m)
  },
  {
    name: "order-success___fr",
    path: "/fr/order/success",
    meta: successCgk9DRWwyJMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/order/success.vue").then(m => m.default || m)
  },
  {
    name: "product-product___pt",
    path: "/pt/product/:product()",
    component: () => import("/usr/src/nuxt-app/pages/product/[product].vue").then(m => m.default || m)
  },
  {
    name: "product-product___es",
    path: "/es/product/:product()",
    component: () => import("/usr/src/nuxt-app/pages/product/[product].vue").then(m => m.default || m)
  },
  {
    name: "product-product___en",
    path: "/product/:product()",
    component: () => import("/usr/src/nuxt-app/pages/product/[product].vue").then(m => m.default || m)
  },
  {
    name: "product-product___fr",
    path: "/fr/product/:product()",
    component: () => import("/usr/src/nuxt-app/pages/product/[product].vue").then(m => m.default || m)
  },
  {
    name: "products-category-product___pt",
    path: "/pt/products/:category()/:product()",
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/[product].vue").then(m => m.default || m)
  },
  {
    name: "products-category-product___es",
    path: "/es/products/:category()/:product()",
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/[product].vue").then(m => m.default || m)
  },
  {
    name: "products-category-product___en",
    path: "/products/:category()/:product()",
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/[product].vue").then(m => m.default || m)
  },
  {
    name: "products-category-product___fr",
    path: "/fr/products/:category()/:product()",
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/[product].vue").then(m => m.default || m)
  },
  {
    name: "products-category___pt",
    path: "/pt/products/:category()",
    meta: index8NbV7IN41TMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "products-category___es",
    path: "/es/products/:category()",
    meta: index8NbV7IN41TMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "products-category___en",
    path: "/products/:category()",
    meta: index8NbV7IN41TMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "products-category___fr",
    path: "/fr/products/:category()",
    meta: index8NbV7IN41TMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "products___pt",
    path: "/pt/products",
    meta: indexXwucbuvb3yMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "products___es",
    path: "/es/products",
    meta: indexXwucbuvb3yMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "products___en",
    path: "/products",
    meta: indexXwucbuvb3yMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "products___fr",
    path: "/fr/products",
    meta: indexXwucbuvb3yMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "promotions-slug___pt",
    path: "/pt/promotions/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/promotions/[slug].vue").then(m => m.default || m)
  },
  {
    name: "promotions-slug___es",
    path: "/es/promotions/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/promotions/[slug].vue").then(m => m.default || m)
  },
  {
    name: "promotions-slug___en",
    path: "/promotions/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/promotions/[slug].vue").then(m => m.default || m)
  },
  {
    name: "promotions-slug___fr",
    path: "/fr/promotions/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/promotions/[slug].vue").then(m => m.default || m)
  },
  {
    name: "register___pt",
    path: "/pt/register",
    meta: registeraxIneg16bwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registeraxIneg16bwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "register___en",
    path: "/register",
    meta: registeraxIneg16bwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registeraxIneg16bwMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "update-user___pt",
    path: "/pt/update-user",
    meta: update_45usercprgsEMgM9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/update-user.vue").then(m => m.default || m)
  },
  {
    name: "update-user___es",
    path: "/es/update-user",
    meta: update_45usercprgsEMgM9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/update-user.vue").then(m => m.default || m)
  },
  {
    name: "update-user___en",
    path: "/update-user",
    meta: update_45usercprgsEMgM9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/update-user.vue").then(m => m.default || m)
  },
  {
    name: "update-user___fr",
    path: "/fr/update-user",
    meta: update_45usercprgsEMgM9Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/update-user.vue").then(m => m.default || m)
  },
  {
    name: component_45stub080fa1cgF9Meta?.name,
    path: "/sitemap.xml",
    component: component_45stub080fa1cgF9
  }
]